import { Button } from "react-bootstrap";
import * as microsoftTeams from "@microsoft/teams-js";
import { useNavigate } from "react-router";
//import {  APP_BASE_URL } from "../utility/constants";
//import { msalInstance } from "../utility/msalConfig";
//import { useSelector } from "react-redux";
//import { useMsal } from "@azure/msal-react";
//import axios from "axios";



const MobileInvite = (props) => {

    //const teamsuserData = useSelector((state) => state?.donation?.teamsData || []);

    // const { instance } = useMsal();
     const navigate = useNavigate();


 const onAllow = () => {
    login(props.chatId);
 };
 
 const onDeny = () => {
    navigate("/loadform", { state: { showDForm: true } });
 };

const login = async (mId) => {
    try {
     
      //let token = await getGraphToken(teamsuserData.email);
      let token = await getGraphTokenMobile();
      const context = {
          subEntityId: "",
          chatId: mId,
        };
         const deeplink = `https://teams.microsoft.com/l/entity/2d4b2d47-2011-4b9e-b789-dbacff73382e/givent?context=${encodeURIComponent(JSON.stringify(context))}`;
      // const deeplink = `https://teams.microsoft.com/l/entity/2d4b2d47-2011-4b9e-b789-dbacff73382e/givent?webUrl=${encodeURIComponent(APP_BASE_URL)}`; 
    
      if(token) await sendMessage(mId, deeplink, token)
    } catch (error) {
      console.error("Login failed:", error);
    }
  };

 const getGraphTokenMobile = async() => {
    //  await microsoftTeams.app.initialize();
      await microsoftTeams.app.initialize();
      const teamsToken = await microsoftTeams.authentication.authenticate({
        url: `${window.location.origin}/auth`, // The page we built
        width: 600,
        height: 535
      });
    if(teamsToken) return teamsToken;
 
   
  };

  

  const sendMessage = async (chatId, tabsAppDeepLink, accessToken) => {
    try {
     
     
      const response = await fetch(
        `https://graph.microsoft.com/v1.0/chats/${chatId}/messages`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            body: {
              content: `Hello <at id="0">everyone</at>! <attachment id="1"></attachment>`, // Fallback text if Adaptive Cards are not supported
              contentType: "html", // Use "html" to support rich formatting
            },
            mentions: [
              {
                id: 0,
                mentionText: "everyone",
                mentioned: {
                  conversation: { id: chatId },
                },
              }
            ],
            importance: "urgent",
            attachments: [
              {
                id:"1",
                contentType: "application/vnd.microsoft.card.adaptive",
                content: JSON.stringify({
                  type: "AdaptiveCard",
                  version: "1.4",
                  body: [
                    {
                    type: "TextBlock",
                    text: "🎉 Your donation form is ready!",
                    wrap: true,
                    weight: "Bolder",
                    size: "Large"
                  },
                  {
                    type: "TextBlock",
                    text: "Go to your meeting and click on the **Givent tab** (in the meeting tabs/content bar) from the top bar to start your donation.",
                    wrap: true,
                    spacing: "Medium"
                  }
                  ],
                  // actions: [
                  //   {
                  //     type: "Action.OpenUrl",
                  //     title: "Givent",
                  //     url: tabsAppDeepLink, // Your deep link here
                  //   },
                  // ],
                }),
              },
            ],
          }),
        }
      );

      if (response.ok) {
        console.log("Message sent successfully!",await response.json());
      
          navigate("/loadform",{ state: { showDForm: true } });
        
      } else {
        const error = await response.json();
        console.error("Error sending message:", error);
      }
    } catch (error) {
      console.error("Error acquiring token or sending message:", error);
    }
  };

return(
    <div className="recurring_transaction_container">
    <div className="recurring_transaction_wrapper">
      <div className="recurring_transaction_card mt_2">
    <div className="recurring_transaction_card_body">
<div className="transaction_info_wrapper">
<div className="form_input_wrapper">
<p className="mt_2"><b>Givent wants to send an invitation to all meeting participants</b></p>
</div>
<div className="form_input_wrapper d-flex justify-content-between" style={{marginBottom:'2rem',marginTop:'2rem'}}>
<Button  className="modal-button allow"  onClick={onAllow}>Allow</Button>
<Button className="modal-button deny"    onClick={onDeny}>Deny</Button>
</div>
</div>
</div>
</div>
</div>
</div>
);

};

export default MobileInvite;